import React, { useContext, useEffect } from "react";
import styles from "./css/header.module.css";
// import stylesLayout from "./css/layout.module.css";
import { IdiomaContext } from '../components/context/IdiomaContext';
import { traducciones } from '../data/headerData';
import { NavLink } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

function Header() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { idioma } = useContext(IdiomaContext);
  const traduccion = traducciones[idioma];
  
  const { ref, inView } = useInView({
    threshold: 0.1,
  });

  return (
<div className={styles.container}>
    <div className={styles.layout}>
      {/* Imagen portada */}
      <div className={styles.img_header}>
      </div>
      {/* Logo */}
      <div className={styles.layout__logoContainer}>        
        <h1 className={styles.layout__title}>{traduccion.title}</h1>
        <h2 className={styles.layout__subtitle}>{traduccion.subtitle}</h2>
      </div>   
      
      <p className={styles.layout__description}>
        {traduccion.description}
      </p>
      <p className={styles.layout__message}>
        {traduccion.message}
      </p>
      <h2 className={styles.layout__subtitle}>{traduccion.subtitle2}</h2>
      <NavLink to="/contact" className={styles.layout__message2}>
        {traduccion.message2}
      </NavLink>
    </div> 
    {/* Layout 2 */}
    <div className={styles.layout__layout2} ref={ref} style={{ opacity: inView ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>
      <h1 className={styles.layout__title2}>{traduccion.title2}</h1>
      {/* <h2 className={styles.layout__subtitle}>{traduccion.subtitle3}</h2> */}
      <div className={styles.img_header2}>
      </div>
      <p className={styles.layout__message_layout2}>
        <span className={styles.highlight}>{traduccion.description2.split(' ').slice(0, 3).join(' ')}</span> {traduccion.description2.split(' ').slice(3).join(' ')}
      </p>
      <p className={styles.layout__title2}>
        {traduccion.message3}
      </p>
      <div className={styles.bar}></div>
      <h1 className={styles.layout__subtitle2}>{traduccion.subtitle4}</h1>
      <ul>
        <li className={styles.layout__list}>{traduccion.list1}</li>
        <li className={styles.layout__list}>{traduccion.list2}</li>
        <li className={styles.layout__list}>{traduccion.list3}</li>
      </ul>

      <NavLink to="/contact" className={styles.layout__message2}>
        {traduccion.button_contact}
      </NavLink>
      <div className={styles.bar}></div>
    </div>
</div>
    
  );
}

export default Header;
